export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const ADD_CART_ITEM = 'ADD_CART_ITEM'
export const FETCH_CART_ITEMS = 'FETCH_CART_ITEMS'
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY'
export const DELETE_CART_ITEM = 'DELETE_CART_ITEM'
export const SIGN_UP = 'SIGN_UP'
export const SIGN_IN = 'SIGN_IN'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE'
